import React from 'react';

const Privacy = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="container-custom">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Last Updated: April 24, 2024
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-16">
          <div className="max-w-5xl mx-auto">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-bold prose-headings:mt-8 prose-p:text-gray-700 prose-li:text-gray-700 prose-li:marker:text-primary">
              <div className="bg-gradient-to-r from-primary/10 via-secondary/10 to-[#FFC600]/10 p-6 rounded-lg mb-8 border-l-4 border-[#FFC600] shadow-sm">
                <h3 className="text-xl font-bold text-primary mb-2">Your Privacy Matters</h3>
                <p className="text-gray-700">
                  Sportify is a mobile fitness platform that connects you with multiple gym facilities, enabling you to book classes, purchase credits, and enjoy universal access memberships—all in one app. Your privacy is our priority.
                </p>
              </div>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">1</span>
                Who We Are
              </h2>
              <p>
                Sportify is a mobile fitness platform that connects you with multiple gym facilities, enabling you to book classes, purchase credits, and enjoy universal access memberships—all in one app. Your privacy is our priority.
              </p>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">2</span>
                What Information We Collect
              </h2>
              <p>
                We may collect personal information such as your name, email address, and phone number when you create an account. We also collect usage data to understand how you interact with our app and, with your permission, location data to show nearby fitness facilities and validate check-ins.
              </p>
              
              <h3 className="text-lg mt-4 mb-2 flex items-center">
                <span className="w-2 h-4 bg-[#FFC600] rounded-sm mr-2"></span>
                Personal Data
              </h3>
              <p>This may include:</p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Name and contact information</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Email address and phone number</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Payment information (securely processed)</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Profile information</span>
                </li>
              </ul>
              
              <h3 className="text-lg mt-4 mb-2 flex items-center">
                <span className="w-2 h-4 bg-[#FFC600] rounded-sm mr-2"></span>
                Location Data
              </h3>
              <p>
                With your permission, we collect location data to show nearby fitness facilities and validate check-ins when you attend a class.
              </p>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">3</span>
                How We Use Your Information
              </h2>
              <p>
                We use your data to manage your bookings, process payments, and provide a personalized experience. This includes sending you notifications about booking confirmations, payment statuses, promotional offers, and important updates.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Manage your account and process bookings</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Process payments securely</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Send booking confirmations and updates</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Provide personalized recommendations</span>
                </li>
              </ul>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">4</span>
                Data Sharing
              </h2>
              <p>
                Your information may be shared with third-party service providers, gym partners, or as required by law. We ensure that all shared data is handled securely and confidentially.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>With Partner Gyms: When you book a class, relevant information is shared with the partner gym facility.</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>With Service Providers: We work with trusted third parties who provide services on our behalf.</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                  <span>Legal Requirements: We may disclose information when required by law.</span>
                </li>
              </ul>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">5</span>
                Your Rights
              </h2>
              <p>
                Depending on your location, you may have the right to access, correct, or delete your personal data, withdraw consent for processing, and request data portability. For inquiries, please contact us at contact@sportify.eg.
              </p>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">6</span>
                Changes to This Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. Significant changes will be communicated via email or through the app. Your continued use of Sportify indicates your acceptance of any updated terms.
              </p>

              <h2 className="flex items-center">
                <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">7</span>
                Contact Us
              </h2>
              <p>
                If you have any questions or concerns about this Privacy Policy, please contact us at contact@sportify.eg.
              </p>
              <p>
                Sportify<br />
                Email: contact@sportify.eg<br />
                Phone: +201060060072
              </p>

              <div className="bg-gradient-to-r from-[#FFC600]/5 to-[#FFC600]/10 p-6 rounded-lg mt-10 text-center border border-[#FFC600]/30 shadow-sm">
                <p className="text-xl font-medium text-gray-800 italic">
                  Thank you for choosing Sportify. <span className="text-[#FFC600] font-bold">Your privacy and security are our utmost priority.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;